export type ReplyLanguageOverride =
  | "auto"
  | "en"
  | "zh"
  | "ms"
  | "ta"
  | "fr"
  | "es"
  | "de";

export type ReplyLanguageOption = {
  value: ReplyLanguageOverride;
  label: string;
  shortLabel: string;
};

export const REPLY_LANGUAGE_OPTIONS: ReplyLanguageOption[] = [
  { value: "auto", label: "Auto", shortLabel: "Auto" },
  { value: "en", label: "English", shortLabel: "EN" },
  { value: "zh", label: "Chinese", shortLabel: "ZH" },
  { value: "ms", label: "Malay", shortLabel: "MS" },
  { value: "ta", label: "Tamil", shortLabel: "TA" },
  { value: "fr", label: "French", shortLabel: "FR" },
  { value: "es", label: "Spanish", shortLabel: "ES" },
  { value: "de", label: "German", shortLabel: "DE" },
];

const REPLY_LANGUAGE_VALUE_SET = new Set<ReplyLanguageOverride>(
  REPLY_LANGUAGE_OPTIONS.map((option) => option.value)
);

export function normalizeReplyLanguageOverride(
  value?: string | null
): ReplyLanguageOverride {
  const normalized = (value || "").trim().toLowerCase();
  if (REPLY_LANGUAGE_VALUE_SET.has(normalized as ReplyLanguageOverride)) {
    return normalized as ReplyLanguageOverride;
  }
  return "auto";
}

export function getReplyLanguageLabel(value: ReplyLanguageOverride): string {
  return (
    REPLY_LANGUAGE_OPTIONS.find((option) => option.value === value)?.label ?? "Auto"
  );
}

export function getReplyLanguageShortLabel(value: ReplyLanguageOverride): string {
  return (
    REPLY_LANGUAGE_OPTIONS.find((option) => option.value === value)?.shortLabel ??
    "Auto"
  );
}

export function toReplyLanguageOverrideDbValue(
  value: ReplyLanguageOverride
): string | null {
  return value === "auto" ? null : value;
}
